// Reloads a tab that outlived a deploy when a lazy import fails (`vite:preloadError`). Once only: a
// second failure in 15s is a broken deploy. No storage, no reload. Literal text, not `toString()`,
// which the two builds print differently and breaks hydration.
export const STALE_BUILD_SCRIPT = [
  'window.addEventListener("vite:preloadError",function(){',
  'try{var k="ac-stale-build-reload",now=Date.now(),',
  "last=Number(window.sessionStorage.getItem(k))||0;",
  "if(now-last<15000)return;",
  "window.sessionStorage.setItem(k,String(now))}",
  "catch(e){return}",
  "window.location.reload()});",
].join("");
